import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddPriceButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      title="Add Price"
      color="primary"
      component={Link}
      to={{
        pathname: "/product_prices/create",
      }}
      state={{ record: { product_id: record.id } }}
    >
      <ButtonIcon /> Add Price
    </Button>
  )
}
